import React from "react";
import { isAndroid, isIOS, osName } from "react-device-detect";
import { ThemeProvider } from "styled-components";
import { ThemeProvider as MuiThemeProvider } from "@mui/styles";

import theme from "../css/theme";
import GlobalStyle from "../css/GlobalStyles";

const StyleProvider = ({ children }) => {
  let os = "android";
  if (isAndroid) {
    os = "android";
  } else if (isIOS) {
    os = "ios";
  } else if (osName === "iOS" || osName === "Mac OS") {
    os = "ios";
  } else {
    os = "android";
  }
  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <GlobalStyle os={os} />
        {children}
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

export default StyleProvider;
